import { colors } from '@ajaibid/components';

const styGroupHeader = {
  color: colors.NEUTRAL_10,
  fontWeight: 700,
  background: colors.SLATE_GRAY_2,
};

/**
 * @param {import('./typedefs').City[]} cityList
 * @returns {import('./typedefs').InputSelectOptions}
 */
export function mapSelectOptions(cityList) {
  // Remove duplicate options
  const reduced =
    cityList?.reduce((a, b) => {
      const exist = a.find((item) => item.id === b.id);
      if (!exist) a.push(b);
      return a;
    }, []) || [];

  // Map to <Input.Select /> options format
  const ret = reduced.map((v) => ({ value: v.id, text: v.name }));

  // Add group headers
  ret.splice(0, 0, {
    value: 'popular',
    text: 'Kota/Kabupaten Populer',
    disabled: true,
    style: styGroupHeader,
  });
  ret.splice(5, 0, {
    value: 'others',
    text: 'Kota/Kabupaten Lainnya',
    disabled: true,
    style: styGroupHeader,
  });
  return ret;
}
